import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = `
Política de Privacidad — Social Cheat Codes

Última actualización: Marzo 2026

1. Información que recopilamos
Recopilamos únicamente la información necesaria para procesar tu compra: nombre, dirección de correo electrónico y datos de pago. No almacenamos datos de tarjetas de crédito directamente; estos son procesados de forma segura por nuestro proveedor de pagos.

2. Uso de la información
Tu información se utiliza exclusivamente para:
• Procesar y entregar tu compra digital.
• Enviarte actualizaciones relacionadas con el producto (solo si das tu consentimiento).
• Mejorar nuestros productos y servicios.

3. Compartición de datos
No vendemos, alquilamos ni compartimos tu información personal con terceros, excepto cuando sea necesario para procesar tu pedido (proveedores de pago) o cuando lo exija la ley.

4. Cookies
Utilizamos cookies esenciales para el funcionamiento del sitio. No utilizamos cookies de seguimiento publicitario.

5. Tus derechos
Puedes solicitar acceso, corrección o eliminación de tus datos personales en cualquier momento enviando un correo electrónico.

6. Seguridad
Implementamos medidas de seguridad estándar de la industria para proteger tu información personal.

7. Cambios
Nos reservamos el derecho de actualizar esta política. Los cambios se publicarán en esta página.
`.trim();
const termsContent = `
Términos y Condiciones — Social Cheat Codes

Última actualización: Marzo 2026

1. Aceptación de los términos
Al realizar una compra, aceptas estos términos y condiciones en su totalidad. Si no estás de acuerdo, no realices la compra.

2. Producto digital
"Social Cheat Codes" es un producto digital (ebook en formato PDF). Una vez completada la compra, recibirás acceso inmediato para descargar el archivo.

3. Licencia de uso
Se te otorga una licencia personal e intransferible para usar el contenido. No está permitido redistribuir, revender, copiar o compartir el material sin autorización expresa.

4. Política de reembolso
Ofrecemos una garantía de devolución de 7 días. Si no estás satisfecho con el producto, puedes solicitar un reembolso completo dentro de los primeros 7 días desde la fecha de compra enviando un correo electrónico.

5. Propiedad intelectual
Todo el contenido del ebook, incluyendo textos, gráficos y diseño, es propiedad del autor y está protegido por las leyes de propiedad intelectual.

6. Limitación de responsabilidad
El contenido se proporciona con fines informativos y educativos. No sustituye el consejo profesional de un psicólogo o terapeuta. No nos hacemos responsables de los resultados individuales obtenidos.

7. Precio beta
El precio actual es un precio promocional de fase beta. Nos reservamos el derecho de modificar el precio en cualquier momento.

8. Modificaciones
Nos reservamos el derecho de modificar estos términos. Los cambios entrarán en vigor inmediatamente tras su publicación.
`.trim();
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-10 px-6 border-t border-gray-100" data-id="element-14">
        <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8" data-id="element-15">
          <button onClick={() => setActiveModal('privacy')} className="text-sm text-gray-400 hover:text-black transition-colors font-medium" data-id="element-16">
            Política de Privacidad
          </button>
          <span className="hidden sm:block text-gray-200" data-id="element-17">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-sm text-gray-400 hover:text-black transition-colors font-medium" data-id="element-18">
            Términos y Condiciones
          </button>
        </div>
        <p className="text-center text-xs text-gray-300 mt-6" data-id="element-19">
          © 2026 Social Cheat Codes. Todos los derechos reservados.
        </p>
      </footer>

      <AnimatePresence data-id="element-20">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-21">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="bg-white rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-22">
              <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-23">
                <h2 className="text-xl font-bold text-black" data-id="element-24">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-xl hover:bg-gray-100 transition-colors" data-id="element-25">
                  <XIcon className="w-5 h-5 text-gray-500" data-id="element-26" />
                </button>
              </div>
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)]" data-id="element-27">
                <pre className="whitespace-pre-wrap text-sm text-gray-600 leading-relaxed font-sans" data-id="element-28">
                  {activeModal === 'privacy' ? privacyContent : termsContent}
                </pre>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}